// extracted by mini-css-extract-plugin
export var aboutSection = "about-module--aboutSection--gaEnL";
export var aboutSectionTitle = "about-module--aboutSectionTitle--14e4R";
export var aboutMobileSidebarPanel = "about-module--aboutMobileSidebarPanel--2CJdJ";
export var contentHeight = "about-module--contentHeight--3tVpx";
export var aboutContainer = "about-module--aboutContainer--1j3aB";